import React from 'react';
import PropTypes from 'prop-types';
import CommonAppSetup from '../../../common/common-app-setup/CommonAppSetup';
import InputContainer from '../input-container/InputContainer';
import Components from '../../../common/Components';
import joinClassNames from "../../../common/JoinClassNames";

const propTypes = {
	// Extra classes that appear on the wrapper
	className: PropTypes.string,

	// The label to show
	label: PropTypes.string.isRequired,

	// Should the label be shown?
	showLabel: PropTypes.bool,

	// Value of this plain text component
	value: PropTypes.string.isRequired,
};

const defaultProps = {
	className: undefined,
	showLabel: true,
};

export default class PlainText extends React.Component {
	render() {
		return (
			<InputContainer className={joinClassNames(
				CommonAppSetup.getClassName(Components.PLAIN_TEXT, 'wrapper'),
				this.props.className
			)}>
				<label className={joinClassNames(
					this.props.showLabel ? '' : 'visually-hidden',
					CommonAppSetup.getClassName(Components.PLAIN_TEXT, 'label')
				)}>
					{this.props.label}
				</label>
				<span className={joinClassNames(
					'form-plain-text',
					this.props.showLabel ? '' : 'no-label',
					CommonAppSetup.getClassName(Components.PLAIN_TEXT, 'text')
				)}>
					{this.props.value}
				</span>
			</InputContainer>
		);
	}
}

PlainText.propTypes = propTypes;
PlainText.defaultProps = defaultProps;